import { deleteCustomRole } from '@gonfalon/openapi/operations/deleteCustomRole';
import { getCustomRole } from '@gonfalon/openapi/operations/getCustomRole';
import { getCustomRoles } from '@gonfalon/openapi/operations/getCustomRoles';
import { internalGetRolePresets } from '@gonfalon/openapi/operations/internalGetRolePresets';
import { internalPatchRolePresets } from '@gonfalon/openapi/operations/internalPatchRolePresets';
import { patchCustomRole } from '@gonfalon/openapi/operations/patchCustomRole';
import { postCustomRole } from '@gonfalon/openapi/operations/postCustomRole';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createInfiniteQueryOptions } from '../internal/createInfiniteQueryOptions';
import { createMutationHook } from '../internal/createMutationHook';
import { createQueryOptions } from '../internal/createQueryOptions';

import { getMemberAccessSummaryQuery, getTeamAccessSummaryQuery } from './accessSummaries';

export const getCustomRolesQuery = createQueryOptions(getCustomRoles);
export const getInfiniteCustomRolesQuery = createInfiniteQueryOptions(getCustomRoles);

export const getCustomRoleQuery = createQueryOptions(getCustomRole);
export const useCreateCustomRole = createMutationHook(postCustomRole);
export const usePatchCustomRole = createMutationHook(patchCustomRole, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: getCustomRoleQuery.partialQueryKey() }),
      queryClient.invalidateQueries({ queryKey: getMemberAccessSummaryQuery.partialQueryKey() }),
      queryClient.invalidateQueries({ queryKey: getTeamAccessSummaryQuery.partialQueryKey() }),
    ]);
  },
});
export const useDeleteCustomRole = createMutationHook(deleteCustomRole, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: getCustomRolesQuery.partialQueryKey() }),
      queryClient.invalidateQueries({ queryKey: getMemberAccessSummaryQuery.partialQueryKey() }),
      queryClient.invalidateQueries({ queryKey: getTeamAccessSummaryQuery.partialQueryKey() }),
    ]);
  },
});

export const getRolePresetsQuery = createQueryOptions(internalGetRolePresets);
export const usePatchRolePresets = createMutationHook(internalPatchRolePresets, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: getRolePresetsQuery.partialQueryKey() }),
      queryClient.invalidateQueries({ queryKey: getMemberAccessSummaryQuery.partialQueryKey() }),
      queryClient.invalidateQueries({ queryKey: getTeamAccessSummaryQuery.partialQueryKey() }),
    ]);
  },
});
